import { MatchViewModel } from '../backend/entryPoints/mapper/mapToMatchViewModel';

export const gameList = ['1.MD', '2.MD', 'WD', 'XD', '1.MS', '2.MS', '3.MS', 'WS'];

export const emptyMatchData: MatchViewModel = {
    games: [
        {
            home_points: 0,
            guest_points: 0,
        },
    ],
    mode: 1,
    mode_string: '1.MD',
    player_home: ['Home Player 1', 'Home Player 2'],
    player_guest: ['Guest Player 1', 'Guest Player 2'],
    home_team: 'Home Team',
    guest_team: 'Guest Team',
    player_positioning: [
        [0, 1],
        [2, 3],
    ],
    server: -1,
    receiver: -1,
    serving_team: -1,
};
